<template>
  <div id="login">
    <div class="contentBox">
      <div class="leftImg">
        <div style="position: absolute;left: 80px;top: 50px">
          <img src="../assets/img/logo.png" alt="">
          <span style="font-size: 20px;color: #FFFFFF;vertical-align: middle">通用仿真软件</span>
        </div>
        <div class="imgArea" style="width: 100%;height: 100%">

        </div>
<!--        <img src="../../static/img/userLeft.png" alt="" >-->
      </div>

      <div  class="rightContent">
        <div>
            <span class="returnIndex" style="cursor: pointer" title="返回主页" @click="$router.push('/')">
          <Icon type="md-home" size="20"/>
        </span>
          <div style="text-align: center">
            <div class="title">欢迎登录</div>
          </div>
          <div style="margin-bottom: 20px;">
            <div>账号</div>
            <Input v-model="loginData.username" style="width: 360px;margin-top: 8px" placeholder="请输入您的账号"/>
          </div>
          <div style="margin-bottom: 20px;">
            <div>密码</div>
            <Input v-model="loginData.password" :type="inputType" style="width: 360px;margin-top: 8px"
                   placeholder="请输入您的密码"/>
            <span @click="changeInputType" style="position: relative;right: 25px;cursor: pointer;top: 3px">
              <img v-if="inputType==='password'" src="../assets/img/eye.png" alt="">
              <img v-if="inputType==='text'" src="../assets/img/hideeye.png" alt="">
          </span>
          </div>
          <div style="margin-bottom: 20px;">
            <div>验证码</div>
            <Input v-model="loginData.captcha" style="width: 170px;margin-top: 8px"/>
            <img @click="changeCap" :src=captchaURL alt="" class="yzm"
                 style="width: 170px;border-radius: 4px;border: 1px solid #DCDFE6;height: 40px;margin-left: 20px;margin-top: 8px">
          </div>

          <div class="forgetPwd" style="text-align: right">
<!--            <span style="cursor: pointer;float: left;" @click="jump('changePassWord')">修改密码</span>-->
            <span style="cursor: pointer;display: inline-block;margin-right: 20px" @click="changForget">忘记密码</span>
          </div>
          <div style="margin-top: 18px;">
            <div  @click="login" style="width: 360px;height: 40px;background:  #0069E0;border-radius: 4px;
            line-height: 40px;text-align: center;color: white;cursor: pointer;font-size: 18px">
              登录
            </div>
            <div  @click="jump('register')" style="width: 360px;height: 40px;border: 1px solid #0069E0;;border-radius: 4px;
            line-height: 40px;text-align: center;color:#0069E0;margin-top: 16px;cursor: pointer;font-size: 18px">
              注册
            </div>
          </div>
        </div>

      </div>

<!--      <div v-if="ifForget" class="rightContent">-->
<!--        <span class="returnIndex" style="cursor: pointer" title="返回主页" @click="$router.push('/')">-->
<!--          <Icon type="md-home" size="20"/>-->
<!--        </span>-->
<!--        <div class="title" style="margin-top: 100px">忘记密码</div>-->
<!--        <div class="inputBox">-->
<!--          <img src="../../static/icon/user.png" class="icons" alt="">-->
<!--          <input v-model="forgetData.username" class="inputkuang" placeholder="请输入您的账号" type="text">-->
<!--        </div>-->
<!--        <div class="inputBox">-->
<!--          <img src="../../static/icon/phone.png" class="icons" alt="">-->
<!--          <input v-model="forgetData.phone" @blur="phoneCheck" class="inputkuang" placeholder="请输入您的手机号"-->
<!--                 type="text">-->
<!--        </div>-->
<!--        <div class="inputBox">-->
<!--          <img src="../../static/icon/yzm.png" class="icons" alt="">-->
<!--          <input v-model="forgetData.messageyzm" class="inputkuang" placeholder="请输入短信验证码" type="text"-->
<!--                 style="width: 175px">-->
<!--          <div class="getMes" @click="getSms">获取短信</div>-->
<!--        </div>-->
<!--        <div class="inputBox">-->
<!--          <img src="../../static/icon/yzm2.png" class="icons" alt="">-->
<!--          <input v-model="forgetData.yzm" class="inputkuang" placeholder="请输入右侧验证码" type="text"-->
<!--                 style="width: 140px">-->
<!--          <img @click="changeCap" :src=captchaURL alt="" class="yzm">-->
<!--        </div>-->
<!--        <div class="inputBox" style="margin-bottom: 10px">-->
<!--          <img src="../../static/icon/password.png" class="icons" alt="">-->
<!--          <input v-model="forgetData.newpsd" @blur="psdCheck" type="password" class="inputkuang"-->
<!--                 placeholder="请输入新密码">-->
<!--        </div>-->
<!--        <div class="tips">密码格式为8-16位字母和数字组合</div>-->
<!--        <div class="inputBox">-->
<!--          <img src="../../static/icon/password.png" class="icons" alt="">-->
<!--          <input v-model="forgetData.twicepsd" @blur="twicepsdCheck" type="password" class="inputkuang"-->
<!--                 placeholder="请再次输入新密码">-->
<!--        </div>-->
<!--        <div class="buttons">-->
<!--          <span class="buttonR" @click="changForget">返回</span>-->
<!--          <span class="buttonL" @click="forgetUserChanged">确认</span>-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </div>

</template>

<script>
import {username, smsCode, reset, captcha, cae_index} from '../api/index'

export default {
  name: "login",
  data() {
    return {
      // 接口地址修改
      captchaURL: captcha + "?_=" + Math.floor(Math.random() * 100),
      // ifForget: false,
      loginData: {
        username: '',
        password: '',
        captcha: ''
      },
      forgetData: {
        username: '',
        phone: '',
        yzm: '',
        messageyzm: '',
        newpsd: '',
        twicepsd: '',

        isphonetrue: false,
        ispsdtrue: false,
        istwicepsdtrue: false
      },

      inputType: 'password',

    }
  },
  methods: {
    changeInputType() {
      if (this.inputType === 'text') {
        this.inputType = 'password'
      } else {
        this.inputType = 'text'
      }

    },
    changForget() {
      this.loginData.username = ''
      this.loginData.password = ''
      this.loginData.captcha = ''

      this.forgetData.username = ''
      this.forgetData.phone = ''
      this.forgetData.yzm = ''
      this.forgetData.messageyzm = ''
      this.forgetData.newpsd = ''
      this.forgetData.twicepsd = ''

      // this.ifForget = !this.ifForget
      this.$Message.error("请联系管理员");
    },

    changeCap() {
      // 接口地址修改
      this.captchaURL = captcha + "?_" + Math.floor(Math.random() * 100)
    },

    login() {
      username(this.loginData).then((res) => {
        let resData = res.data
        console.log(resData)
        if (resData.result.success == false) {
          this.changeCap();
          this.$Message.error(resData.result.info);
        }
        if (resData.result.success == true) {

          this.$cookies.set("userId", resData.result.data.user.id, '30d')
          this.$cookies.set("userName", resData.result.data.user.username, '30d')
          this.$cookies.set("nickName", resData.result.data.user.nickname, '30d')
          this.$cookies.set("auth", resData.result.data.auth, '30d')
          this.$cookies.set("isLogin", true, '30d')

          if(this.$route.params.intoWeb){
            window.location.href = cae_index;
          }else{
            this.$router.push('/')
          }

          // 地址修改
          // window.location.href = "http://localhost:8081/#/cloudDisk";
          // window.location.href='/sep/#/cloudDisk'


        }
      }).catch((error) => {
        console.log(error);
      });


    },

    phoneCheck() {
      let reg = /^1\d{10}$/;
      console.log(reg.test(this.forgetData.phone))
      if (reg.test(this.forgetData.phone) === false) {
        this.forgetData.isphonetrue = false;
        this.$Message.error('手机号格式错误');
      } else {
        this.forgetData.isphonetrue = true;
      }
    },

    getSms() {
      let obj = {
        mobilephone: this.forgetData.phone,
        captcha: this.forgetData.yzm
      }
      if (this.forgetData.isphonetrue == true) {
        smsCode(obj).then((res) => {
          let resData = res.data
          if (resData.result.success == false) {
            this.changeCap();
            this.$Message.error(resData.result.info);
          }
          if (resData.result.success == true) {
            this.$Message.success(resData.result.info);
          }
        }).catch((error) => {
          console.log(error);
        });
      } else {
        this.$Message.error('手机号格式错误');
      }
    },

    psdCheck() {
      // let reg = /(?!.*\s)(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,16}$/;
      let reg = /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{8,16}$/;
      if (reg.test(this.forgetData.newpsd) == false) {
        this.$Message.error('密码格式错误');
        this.forgetData.ispsdtrue = false
      } else {
        this.forgetData.ispsdtrue = true
      }
    },

    twicepsdCheck() {
      if (this.forgetData.newpsd != this.forgetData.twicepsd) {
        this.$Message.error('两次输入密码不符');
        this.forgetData.istwicepsdtrue = false
      } else {
        this.forgetData.istwicepsdtrue = true
      }
    },

    forgetUserChanged() {
      if (this.forgetData.ispsdtrue == false) {
        this.$Message.error('密码格式错误');
      }
      if (this.forgetData.ispsdtrue == true && this.forgetData.istwicepsdtrue == false) {
        this.$Message.error('两次输入密码不符');
      }
      if (this.forgetData.ispsdtrue == true && this.forgetData.istwicepsdtrue == true) {
        let obj = {
          username: this.forgetData.username,
          captcha: this.forgetData.yzm,
          mobilephone: this.forgetData.phone,
          smsCode: this.forgetData.messageyzm,
          password: this.forgetData.newpsd
        }
        reset(obj).then((res) => {
          let resData = res.data
          if (resData.result.success == false) {
            this.$Message.error(resData.result.info);
          }
          if (resData.result.success == true) {
            this.$Message.success(resData.result.info);
            this.changForget()
          }
        }).catch((error) => {
          console.log(error);
        })
      }
    },

    jump(target) {
      this.$router.push(target)
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.login();
      }
    },


  },

  mounted() {
    console.log(this.$route.params.intoWeb);
    window.addEventListener('keydown', this.keyDown);


  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false);
  }

}
</script>

<style scoped lang="scss">
#login {
  background-color: #4871E1;
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.contentBox {
  display: flex;
  width: 100%;
  height: 100%;
  background: #FFFFFF;


  .leftImg {
    width: 57%;
    display: inline-block;
    .imgArea{
      background: url("../../static/img/userLeft.png") no-repeat;
      background-size: cover;
    }
  }

  .rightContent {
    display: flex;
    width: 43%;
    height: 100vh;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    .title {
      font-size: 30px;
      color: #333333;
      margin-bottom: 50px;

    }

    .inputBox {
      display: inline-block;
      background: #FFFFFF;
      border: 1px solid #DCDCDC;
      border-radius: 25px;
      width: 340px;
      height: 50px;
      margin-bottom: 20px;
      padding: 15px 30px;
      text-align: left;

      .icons {
        width: 22px;
      }

      .inputkuang {
        margin-left: 15px;
        height: 20px;
        width: 235px;
        border: none;
        outline: none;

        &:focus {
          border: none;
        }
      }

      .yzm {
        float: right;
        top: -7px;
        right: -13px;
        position: relative;
        width: 80px;
        height: 30px;
      }
    }

    .forgetPwd {
      //display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #0069E0;
      //justify-content: space-between;
    }

    .getMes {
      cursor: pointer;
      font-size: 14px;
      color: #2651BB;
      text-align: right;
      display: inline-block;
      width: 56px;
      height: 20px;
    }

    .buttons {
      margin-top: 15px;
      display: inline-block;
      width: 340px;

      .buttonR {
        cursor: pointer;
        display: inline-block;
        background: #E5E7ED;
        border-radius: 25px;
        width: 160px;
        height: 50px;
        font-size: 16px;
        color: #5E677D;
        text-align: center;
        padding: 15px;
        float: left;
      }

      .buttonL {
        cursor: pointer;
        display: inline-block;
        background: #2651BB;
        border-radius: 25px;
        width: 160px;
        height: 50px;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        padding: 15px;
        float: right;
      }
    }

    .tips {
      margin-bottom: 10px;
      padding-left: 30px;
      width: 340px;
      display: inline-block;
      text-align: left;
      font-size: 14px;
      color: #666666;
    }
  }
}

.returnIndex {
  position: absolute;
  display: inline-block;
  right: 15px;
  float: right;
  top: 15px;
}


/*.loginBox {*/
/*  border: 3px white solid;*/
/*  margin-top: 12%;*/
/*  text-align: center;*/
/*  padding: 50px 0;*/
/*  background: rgba(255, 255, 255, .6);*/

/*  .backindex {*/
/*    position: absolute;*/
/*    right: 15px;*/
/*    top: 15px;*/
/*    font-size: 16px;*/
/*    color: black;*/
/*    cursor: pointer;*/
/*  }*/

/*  .title {*/
/*    margin-bottom: 40px;*/
/*    color: black;*/
/*  }*/

/*  .inputLabel {*/
/*    color: black;*/
/*    font-size: 16px;*/
/*    padding-top: 5px;*/
/*  }*/

/*  .inputBox {*/
/*    background: none;*/
/*    border: white 2px solid !important;*/
/*  }*/

/*  .yzmimg {*/
/*    img {*/
/*      width: 100%;*/
/*      height: 32px;*/
/*    }*/

/*  }*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/login.vue